import React from 'react';

// The domain drawers (booking / car / category / claim / care / trip /
// receipt / fuelTransaction / users) all nest each other inside
// DrawerLayout's nestedDrawers slot. Importing each other's modules for that
// made their module graph circular, so drawer shells render sibling drawers
// through this registry instead of importing them. registerNestedDrawers.ts —
// imported once at the app entry — binds every name before anything renders.
export type NestedDrawerName =
  | 'booking'
  | 'carEdit'
  | 'categoryEdit'
  | 'claim'
  | 'care'
  | 'trip'
  | 'receipt'
  | 'fuelTransaction'
  | 'users';

const registry: Partial<Record<NestedDrawerName, React.ComponentType>> = {};

export const registerNestedDrawer = (
  name: NestedDrawerName,
  drawer: React.ComponentType
): void => {
  registry[name] = drawer;
};

const NestedDrawer: React.FC<{ name: NestedDrawerName }> = ({ name }) => {
  const Drawer = registry[name];
  return Drawer ? <Drawer /> : null;
};

export default NestedDrawer;
